/** @format */

import Sidebar from "./Sidebar"
import Header from "./Header";
import { Outlet, Link } from "react-router-dom";
import { useEffect } from "react";
const Main = ({ socket }) => {

  useEffect(() => {

  }, []);

  return (
    <div className="wrapper">
      <Sidebar />
      <div id="content">
        <Header socket={socket}/>
        <Outlet />
      </div>
    </div>

  );
};

export default Main;
